<script setup>
import {Link} from '@inertiajs/vue3';
import Pagination from "@/Components/Pagination.vue";
import Grid from "@/Components/Grid.vue";
import Labels from "@/Components/Labels.vue";
import {generate} from "geopattern";

defineProps({
    items: Object, // Pagination
    gridSize: Number,
    hideLabels: {
        type: Array,
        default: () => [],
    },
    hideSubtitle: {
        type: String,
        default: null,
    },
});
</script>

<template>
    <section aria-labelledby="products-heading" class="w-full pt-12">
        <h2 id="products-heading" class="sr-only">Collections</h2>
        <Grid>
            <Link v-for="item in items.data" :key="item.name" :href="item.url" class="group relative">
                <Labels v-if="item.labels?.filter(l => !hideLabels.includes(l)).length" :product="{ labels: item.labels.filter(l => !hideLabels.includes(l)), discount: item.discount }"/>
                <div class="aspect-h-1 aspect-w-2 overflow-hidden rounded-md -z-10">
                    <img :src="item.backgroundImage ?? generate(item.name).toDataUri()" :alt="item.name"
                         class="h-full w-full object-cover object-center group-hover:scale-110 transition transition-duration-300"/>
                    <div v-if="item.backgroundImage" aria-hidden="true" class="absolute inset-0 bg-gray-900 opacity-20 group-hover:opacity-50 transition transition-duration-300"/>
                    <div class="absolute inset-0 flex flex-col items-center justify-center text-center px-2 drop-shadow-md">
                        <h3 class="text-balance text-xl md:text-2xl text-white font-bold tracking-tight">
                            {{ item.name }}
                        </h3>
                        <span v-if="item.subtitle && item.subtitle !== hideSubtitle" class="text-base text-gray-100 font-medium tracking-tight">
                            {{ item.subtitle }}
                        </span>
                    </div>
                </div>
            </Link>
        </Grid>
    </section>
    <Pagination :pagination="items"/>
</template>
